import React, { useState, useCallback } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { removeToken } from "../../utils/cookies";
import { logout } from "../../redux/slice/userSlice";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();


  const handleLogout = useCallback(() => {
    removeToken();
    dispatch(logout());
    navigate("/login");
  }, [dispatch, navigate]);

  const openSidebar = useCallback(() => {
    setIsSidebarOpen(true);
  }, []);

  const closeSidebar = useCallback(() => {
    setIsSidebarOpen(false);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col lg:flex-row lg:h-screen">
      <div className="lg:hidden">
        {/* Mobile Navbar */}
        <div className="fixed top-0 left-0 right-0 z-50">
          <Navbar
            onMenuClick={openSidebar}
            onLogout={handleLogout}
            currentPath={pathname}
          />
        </div>

        <Sidebar
          isOpen={isSidebarOpen}
          onClose={closeSidebar}
          currentPath={pathname}
          onLogout={handleLogout}
          isMobile
        />
      </div>
      <div className="hidden lg:flex h-screen">
        <Sidebar
          isOpen
          onClose={closeSidebar}
          currentPath={pathname}
          onLogout={handleLogout}
          isMobile={false}
        />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden lg:overflow-auto">
        {/* Desktop Navbar */}
        <div className="hidden lg:block">
          <Navbar
            onMenuClick={openSidebar}
            onLogout={handleLogout}
            currentPath={pathname}
            hideLogo
          />
        </div>
        <main className="flex-1 overflow-auto pt-16 lg:pt-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
